<app-header [menu]="menu" />

<app-tp-watermark *ngIf="!isProduction" />

<main>
  <router-outlet />
</main>

<app-footer [menu]="menuFooter" />
